import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="container-main pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">Disclaimer</span>
          </nav>

          <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-6">
            Disclaimer
          </h1>

          <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed">
            <p className="text-base mb-4">
              The information provided on AllChinaBuySpread is for general informational and educational purposes only. By using this website, you agree to the following terms:
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Independent Resource</h2>
            <p className="text-base mb-4">
              AllChinaBuySpread is an independent website and is not affiliated with, endorsed by, or officially connected to AllChinaBuy or any related platforms. All opinions, reviews, and guides represent our independent research and analysis.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">No Official Affiliation</h2>
            <p className="text-base mb-4">
              We do not claim any official partnership with AllChinaBuy. Product links on this site redirect to AllChinaBuy and kaspreadsheet.com, which are third-party platforms. We do not control these external websites and are not responsible for their content, policies, or services.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Information Accuracy</h2>
            <p className="text-base mb-4">
              While we strive to provide accurate and up-to-date information, we make no representations or warranties of any kind about the completeness, accuracy, reliability, or availability of the information on this website. Any reliance you place on such information is strictly at your own risk.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">No Financial or Legal Advice</h2>
            <p className="text-base mb-4">
              Nothing on this website constitutes financial, legal, or professional advice. This site is for educational and research purposes only. Always conduct your own research and due diligence before making any purchasing decisions.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">External Links</h2>
            <p className="text-base mb-4">
              This website contains links to external websites. We are not responsible for the content, privacy policies, or practices of any third-party websites. When you click on external links, you do so at your own discretion.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">User Responsibility</h2>
            <p className="text-base mb-4">
              Users are solely responsible for their interactions with AllChinaBuy and any sellers on that platform. We strongly encourage all users to verify seller reputation, review QC photos, and use secure payment methods before completing any transactions.
            </p>

            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8 mb-3">Changes to This Disclaimer</h2>
            <p className="text-base mb-6">
              We may update this disclaimer from time to time. The current version was last updated on August 25, 2026. Please review this page periodically for any changes.
            </p>

            <div className="mt-10 bg-primary-50 rounded-lg p-6 md:p-8 text-center border border-primary-200/50">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">Back to Homepage</h3>
              <p className="text-sm text-foreground-600 mb-4">Continue browsing our independent resources.</p>
              <a href="/" className="btn-primary inline-flex">
                Go to Homepage
                <i className="ri-arrow-right-line ml-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}